var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6695 23.4937L27.9195 21.7437V2.82625C27.9195 2.55792 27.8075 2.31117 27.5835 2.086C27.3595 1.86083 27.1122 1.74883 26.8415 1.75H15.407L11.6375 5.5195L10.3793 4.2805L14.6598 0H26.8433C27.6483 0 28.3208 0.270083 28.861 0.81025C29.4012 1.35042 29.6707 2.02242 29.6695 2.82625V23.4937ZM32.1598 33.439L7.92925 9.2085L6.9195 10.2182V28.6737C6.9195 28.9421 7.0315 29.1888 7.2555 29.414C7.4795 29.6392 7.72625 29.7512 7.99575 29.75H26.8433C27.1116 29.75 27.3583 29.638 27.5835 29.414C27.8087 29.19 27.9207 28.9433 27.9195 28.6737V26.712L29.6695 28.462V28.672C29.6695 29.4782 29.4 30.1513 28.861 30.6915C28.322 31.2317 27.6488 31.5012 26.8415 31.5H7.9975C7.19133 31.5 6.51875 31.2305 5.97975 30.6915C5.44075 30.1525 5.17067 29.4799 5.1695 28.6737V9.49025L6.692 7.96775L0 1.27925L1.2495 0.04025L33.397 32.1895L32.1598 33.439Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSim);
export default __webpack_public_path__ + "static/media/no_sim.3db967cbd6c37474bc409cfa183b28d2.svg";
export { ForwardRef as ReactComponent };